import { Box, TableCell } from "@mui/material";
import StyledTableRow from "../../../components/table/styled-table-row";
import TableActionButton from "../../../components/table/table-action-button";
import { SocialDistanceIcon } from "../../../shared/icons";
import { BiometricDeviceUser, BiometricDeviceUserRequest } from "../../../service/model/biometric.model";
import BiometricUserForm from "./biometric-user-form";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectLoggedInUser } from "../../auth/auth.slice";
import { updateBiometricDeviceUser } from "../biometric-user.slice";
import { selectMembers } from "../../members/member.slice";
import { selectUsers } from "../../user/user.slice";

interface TableRowProps {
    readonly deviceUser: BiometricDeviceUser
}

const BiometricUserTableRow: React.FC<TableRowProps> = ({ deviceUser }) => {
    const dispatch = useAppDispatch();
    const members = useAppSelector(selectMembers);
    const staff = useAppSelector(selectUsers);
    const [showBiometricUserForm, setShowBiometricUserForm] = useState(false);
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUser = loggedInUserDetails?.user;

    // const handleDelete = () => {
    //     dispatch(BiometricUserSlice.deleteBiometricDeviceUser(device.id))
    //     setShowDeleteDialog(false)
    // }

    // const handleDeleteCancel = () => {
    //     setShowDeleteDialog(false)
    // }

    const handleSubmit = (data: BiometricDeviceUserRequest) => {
        loggedInUser && dispatch(updateBiometricDeviceUser({ ...data, id: deviceUser.id })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowBiometricUserForm(false);
            }
        });
    };

    const getUserType = () => {
        if (deviceUser.memberId) return 'Member';
        if (deviceUser.businessUserId) return 'Staff';
        return 'Unassigned';
    };

    const getUserName = () => {
        if (deviceUser.memberId) {
            const member = members.find(m => m.id === deviceUser.memberId);
            return member ? `${member.firstName} ${member.lastName}` : 'Unknown Member';
        }
        if (deviceUser.businessUserId) {
            const user = staff.find(u => u.id === deviceUser.businessUserId);
            return user ? `${user.firstName} ${user.lastName}` : 'Unknown Staff';
        }
        return '';
    };

    return (
        <>
            <StyledTableRow key={deviceUser.id}>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Device Username</Box>{deviceUser.name}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">PIN</Box>{deviceUser.devicePin}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">User Type</Box>{getUserType()}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Name</Box>{getUserName()}</TableCell>
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">Actions</Box>
                    {/* <TableActionButton onClick={() => navigate(`/devices/${device.id}/users`)} label="View users" icon={<PeopleIcon />} /> */}
                    <TableActionButton onClick={() => setShowBiometricUserForm(true)} label="Link user" icon={<SocialDistanceIcon />} />
                    {/* <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />} /> */}
                </TableCell>
            </StyledTableRow>
            {showBiometricUserForm &&
                <BiometricUserForm deviceUser={deviceUser} editable={true} onClose={() => setShowBiometricUserForm(false)} onSubmit={handleSubmit} />
            }
        </>
    );
}

export default BiometricUserTableRow;